module.exports = __webpack_public_path__ + "img/4.8dc901f4.jpg";